export const getTransactionsUrl = (page = 1) => `admin/new-transactions?page=${page}`;

export const getSingleTransactionUrl = (id, page = 1) => {
   return `admin/new-transactions/${id}?page=${page}`;
};
